import { render } from "./AvatarEditor.vue?vue&type=template&id=e415c880&scoped=true"
import script from "./AvatarEditor.vue?vue&type=script&lang=js"
export * from "./AvatarEditor.vue?vue&type=script&lang=js"

import "./AvatarEditor.vue?vue&type=style&index=0&id=e415c880&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e415c880"]])

export default __exports__